import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  backgroundColors: {
    primary: '#396AE8',
    secondary: '#303765',
    darkBlue: '#141A46',
    skyBlue: '#E9F0FD',
    white: '#FFFFFF',
    lightSkyBlue: '#F3F7FF',
    gray: '#E5E5E5',
    green: '#317A36',
    joinNetwork: '#E8E9F1',
    lightYellow: '#FFFBF4',
    lighterBlue: '#F1F9FE',
    lightBlue: '#DAEFFD',
    lightGray: '#F4F5F7',
    darkGray: '#949393',
    lightPrimary: '#93bafa',
    success:'#39d544'
  },
  fontFamily: {
    manrope: "'Manrope', sans-serif",
    montserrat: "'Montserrat', sans-serif",
  },
  textColors: {
    white: '#FFFFFF',
    black: '#000000',
    gray: '#6B6B6B',
    'gray-500': '#757575',
    'gray-900': '#303030',
    primary: '#396AE8',
    brown: '#7d4d18',
    label: '#44526c',
    secondary: '#253858',
    secondary2: '#42526e',
    lebel2: '#194E8A',
    red: '#E74C3C',
    korma: '#984F11',
    link: '#2B79D4',
    indigo:'#5f44a1'
  },
  fontSize: {
    xxxl: '32px',
    xxl: '26px',
    xxyl: '24px',
    xl: '22px',
    lg: '20px',
    mdl: '18px',
    base: '16px',
    md: '14px',
    sm: '12px',
    xs: '11px',
    xxs: '10px',
    xxxs: '9px',
  },
  fontWeight: {
    bold: '800',
    midbold: '700',
    semibold: '600',
    normal: '400',
  },
};

export default theme;
